/**
 * Génère un slug URL-friendly depuis un nom libre.
 * - Retire les accents
 * - Remplace les non-alphanumériques par des tirets
 * - Compresse les tirets multiples
 * - Ajoute un suffixe hex court pour limiter les collisions
 */
export function slugify(input: string, withSuffix = true): string {
    const base = input
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/-{2,}/g, '-')
        .slice(0, 40);

    const cleaned = base || 'workspace';
    if (!withSuffix) return cleaned;

    const suffix = Math.random().toString(36).slice(2, 7);
    return `${cleaned}-${suffix}`;
}
